import React, {useState} from 'react';
import Box from 'sail/Box';
import {ButtonLink} from 'sail/Button';
import {defineMessages, FormattedMessage} from 'react-intl';
import CardPaymentDemo from './demo/CardPayment';
import CheckoutDemo from './demo/Checkout';
import {useGuide} from '../../data/GuideProvider';
import '../../css/Demo.scss';

const messages = defineMessages({
  preview: {
    id: 'docsApp.ib.demo.preview',
    description: 'Label for preview tab',
    defaultMessage: 'Preview',
  },
});

export default () => {
  const {activeDemo} = useGuide();
  const [expanded, setExpanded] = useState(true);

  if (!activeDemo) {
    return null;
  }
  const Demo = activeDemo.type === 'card' ? CardPaymentDemo : CheckoutDemo;
  return (
    <Box className="Panel">
      <Box
        padding={{top: 12, right: 24, left: 24, bottom: 0}}
        flex={{justifyContent: 'flex-start', alignItems: 'center'}}
        style={{
          opacity: 1,
          transform: 'translateY(0px)',
          transition:
            'height 0s, transform 0.1s ease-in-out, opacity 0.1s ease-in-out',
        }}
      >
        <ButtonLink
          display="inline-flex"
          icon={expanded ? 'chevronUp' : 'chevronDown'}
          iconPosition="left"
          size="small"
          label={<FormattedMessage {...messages.preview} />}
          onClick={() => {
            setExpanded(!expanded);
          }}
          style={{
            marginTop: 0,
            marginRight: 0,
            padding: 0,
            paddingBottom: '12px',
          }}
        />
      </Box>
      {expanded && (
        <Box
          flex={{
            direction: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          className="Demo"
        >
          <Box>
            <Demo />
          </Box>
        </Box>
      )}
    </Box>
  );
};
